var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5003 22C16.7931 22 21.0837 17.5228 21.0837 12C21.0837 6.47715 16.7931 2 11.5003 2C6.2076 2 1.91699 6.47715 1.91699 12C1.91699 17.5228 6.2076 22 11.5003 22Z",
    stroke: "#003DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.71094 9.00057C8.93625 8.33224 9.38096 7.76868 9.96631 7.4097C10.5517 7.05073 11.2399 6.91951 11.9091 7.03928C12.5783 7.15906 13.1852 7.52209 13.6225 8.0641C14.0597 8.6061 14.299 9.29209 14.298 10.0006C14.298 12.0006 11.423 13.0006 11.423 13.0006",
    stroke: "#003DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5 17H11.5105",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.2ff7655f55d10ec9ec37a101bf1e5876.svg";
export { ForwardRef as ReactComponent };